"use strict";
/**
 * Unified style utilities for all scorecard display components.
 * All style functions accept `factor` (UI scaling) as their first argument.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toParDisplay = exports.legendStackStyle = exports.labelStackStyle = exports.aggStackStyle = exports.holeStackStyle = exports.holeValueStyle = void 0;
/** Background/border styling for an individual hole score cell based on result vs par. */
const holeValueStyle = (displayScore, par, factor) => ({
    width: 18 * factor,
    height: 18 * factor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: displayScore > 0 && displayScore < par ? '50%' : '4px',
    backgroundColor: displayScore === 0 ? 'transparent' :
        displayScore < par ? 'rgb(166, 221, 178)' :
            displayScore > par ? 'rgb(240, 131, 131)' :
                'transparent',
    border: displayScore === 0 ? '1px solid transparent' :
        displayScore < par - 1 ? '4px double rgb(20, 68, 24)' :
            displayScore > par + 1 ? '4px double rgb(112, 18, 18)' :
                '4px solid transparent',
});
exports.holeValueStyle = holeValueStyle;
/** Container for a single hole data cell. */
const holeStackStyle = (factor, height) => ({
    width: 35 * factor,
    height: (height ?? 42) * factor,
    minWidth: 35 * factor,
    borderBottom: '1px solid darkgray',
    justifyContent: 'center',
    alignItems: 'center',
});
exports.holeStackStyle = holeStackStyle;
/** Container for aggregate cells (Front, Back, Total, +/-). Background driven by type. */
const aggStackStyle = (factor, type, height) => ({
    width: 40 * factor,
    height: (height ?? 42) * factor,
    minWidth: 40 * factor,
    borderBottom: '1px solid darkgray',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '550',
    backgroundColor: type === 'front' || type === 'back' ? '#f5f5f5' :
        type === 'total' ? '#e0e0e0' :
            '#e8f4f8',
});
exports.aggStackStyle = aggStackStyle;
/** Fixed left label column cell (Hole / player name). */
const labelStackStyle = (factor, height) => ({
    borderBottom: '1px solid darkgray',
    borderRight: '1px solid darkgray',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '5px',
    backgroundColor: 'sepia.background',
    height: (height ?? 42) * factor,
});
exports.labelStackStyle = labelStackStyle;
/** Flex row cell used in the legend/footer bar. */
const legendStackStyle = (factor) => ({
    height: 50 * factor,
    minWidth: 35 * factor,
    justifyContent: 'center',
    alignItems: 'center',
});
exports.legendStackStyle = legendStackStyle;
/**
 * Returns the colour and display string for a +/- (score-to-par) value.
 * Convention: under par = sepia, even = black, over par = primary.
 */
const toParDisplay = (total, totalPar) => {
    if (total === 0 || totalPar === 0)
        return { text: '-', colorKey: 'inherit' };
    const rel = total - totalPar;
    if (rel === 0)
        return { text: 'E', colorKey: 'black' };
    if (rel < 0)
        return { text: rel.toString(), colorKey: 'sepia.main' };
    return { text: `+${rel}`, colorKey: 'primary.main' };
};
exports.toParDisplay = toParDisplay;
